import React from "react";
import { Link } from "react-router-dom";
import ContactForm from "./ContactForm";

const Contact = () => {
  return (
    <div className="bg-gray-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12">
        {/* Contact Info */}
        <div className="space-y-6">
          <h1 className="text-4xl font-bold text-gray-800">Get in Touch</h1>
          <p className="text-gray-600">
            We're here to help and answer any question you might have. We look
            forward to hearing from you.
          </p>

          <div className="space-y-4">
            <div>
              <h3 className="text-lg font-semibold text-gray-700">📧 Email</h3>
              <p className="text-gray-600">
                <a
                  href="mailto:support@purecleanshopping.info"
                  className="text-indigo-600 hover:underline"
                >
                  support@purecleanshopping.info
                </a>
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-700">📞 Phone</h3>
              <p className="text-gray-600">
                <a
                  href="tel:+12016792499"
                  className="text-indigo-600 hover:underline"
                >
                  +1 815-634-5223
                </a>
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-700">
                📍 Address
              </h3>
              <p className="text-gray-600">
                1132 Black Diamond Dr, Coal City, IL 60416,
                <br />
                United States.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-700">
                Need More Help?
              </h3>
              <p className="text-gray-600">
                Check out our{" "}
                <Link to="/faqs" className="text-indigo-600 hover:underline">
                  Frequently Asked Questions
                </Link>{" "}
                or read our{" "}
                <Link to="/blog" className="text-indigo-600 hover:underline">
                  Blog
                </Link>{" "}
                for tips and updates.
              </p>
            </div>
          </div>
          <iframe
src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2004.2079070348427!2d-88.28175626815874!3d41.27437011708251!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880e827c47da222f%3A0x87a96fca3f671c00!2s1132%20Black%20Diamond%20Dr%2C%20Coal%20City%2C%20IL%2060416%2C%20USA!5e0!3m2!1sen!2sin!4v1768240240972!5m2!1sen!2sin"            width="600"
            height="200"
            className="border border-1 p-2 rounded-xl shadow-xl"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        {/* Contact Form */}
        <div className="bg-white shadow-md rounded-lg p-8">
          <ContactForm />
        </div>
      </div>
    </div>
  );
};

export default Contact;
